// 탭 안 콘텐츠 카드 — 한 번에 하나만 마운트되므로 접기/펼치기 없이 항상 펼침.
// 톤: 테두리 대신 은은한 그림자로 경계를 표현(Toss 스타일) — 박스 안에 박스가 겹쳐 보이는
// 느낌을 줄이려고 border 대신 shadow 를 씀(2026-07-15 리디자인).
export default function Panel({ title, action, children }) {
  return (
    <div className="rounded-2xl bg-white p-4 shadow-[0_1px_2px_rgba(15,23,42,0.04),0_8px_24px_-12px_rgba(15,23,42,0.08)] sm:p-5">
      {(title || action) && (
        <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
          {title && <span className="text-sm font-semibold text-ink-800">{title}</span>}
          {action}
        </div>
      )}
      {children}
    </div>
  );
}
